import SectionReveal from './SectionReveal';

export default function TimelineSection({ t }) {
  return (
    <section id="timeline" className="relative px-3 py-20 md:px-10">
      
      <div className="mx-auto max-w-7xl space-y-12">
        
        {/* Заголовок */}
        <SectionReveal>
          <div className="md:border-l-4 border-l-2 border-[#0FA4E8] bg-gray-50 p-3 md:p-10">
            <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-3">
              {t.timelineTitle}
            </h2>
            <p className="text-base text-slate-600">
              {t.timelineSubtitle}
            </p>
          </div>
        </SectionReveal>

        {/* Сетка шагов */}
        <div className="grid gap-4 p-3 sm:grid-cols-2 lg:grid-cols-3">
          {t.servicesSteps.map((step, idx) => (
            <SectionReveal key={idx} delay={idx * 60}>
              <div className="group border border-gray-100 hover:border-[#0FA4E8]/30 transition-all bg-white hover:shadow-sm h-full flex flex-col">
                
                {/* Фото */}
                <div className="relative h-52 overflow-hidden flex-shrink-0">
                  {step.image ? (
                    <img 
                      src={step.image} 
                      alt={step.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-100" />
                  )}
                  
                  {/* Номер */}
                  <div className="absolute top-3 left-3">
                    <span className="inline-flex items-center justify-center w-8 h-8 bg-[#0FA4E8] text-xs font-black text-white">
                      {step.num}
                    </span>
                  </div>
                </div>

                {/* Контент */}
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="text-base font-bold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors mb-2 min-h-[48px]">
                    {step.title}
                  </h3>
                  <p className="text-sm text-slate-500 leading-relaxed flex-1">
                    {step.desc}
                  </p>
                  
                  {/* Линия */}
                  <div className="mt-4 h-0.5 w-0 group-hover:w-12 bg-[#0FA4E8] transition-all duration-500" />
                </div>

              </div>
            </SectionReveal>
          ))}
        </div>

      </div>
    </section>
  );
}